<app-layout type="white" size="100%">
  <app-breadcrumb [breadcrumbItems]="[
  { label: ('breadcrumb.login' | translate), link: '/' },
  { label: ('breadcrumb.register' | translate) }
]"></app-breadcrumb>
  <div class="change-password-container">
    <div class="form-section">
      <app-title title="register.title" />

      <app-stepper [steps]="['register.stepper.step1', 'register.stepper.step2', 'register.stepper.step3']"
        [currentStep]="0" />

      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <app-input label="register.email" [formGroup]="form" name="email" type="email" [required]="true" />
        @if (form.get('email')?.invalid && form.get('email')?.touched) {
        <div class="error">{{ 'register.emailInvalid' | translate }}</div>
        }

        <app-input label="register.confirmEmail" [formGroup]="form" name="confirmEmail" type="email"
          [required]="true" />
        @if (emailMismatch) {
        <div class="error">{{ 'register.emailMismatch' | translate }}</div>
        }

        <app-input label="register.password" [formGroup]="form" name="password" type="password" [required]="true"
          (input)="checkPassword()" />

        <app-input label="register.confirmPassword" [formGroup]="form" name="confirmPassword" type="password"
          [required]="true" />
        @if (passwordMismatch) {
        <div class="error">{{ 'register.passwordMismatch' | translate }}</div>
        }

        @if (error) {
        <div class="error">{{ error }}</div>
        }

        <label class="terms">
          <input type="checkbox" formControlName="terms" />
          <span [innerHTML]="'register.terms' | translate"></span>
        </label>

        <div class="button-group">
          @if (loading) {
          <app-spinner></app-spinner>
          } @else {
          <app-button variant="primary">
            <button [disabled]="!form.valid || !!emailMismatch || !!passwordMismatch" type="submit"
              data-testid="register-submit">
              {{ 'register.submit' | translate }}
            </button>
          </app-button>
          }
          <a class="btn-flat" routerLink="/" queryParamsHandling="preserve">{{ 'register.backToLogin' | translate }}</a>
        </div>
      </form>
    </div>

    <div class="requirements-section">
      <app-password-requirements [validations]="validations" />
    </div>
  </div>
</app-layout>